import { BreadcrumbItem } from '@components/atoms/ui-kit/breadcrumbs.tsx';

export const buildPlansBoBreadcrumbTrail = (
  modelName: string
): BreadcrumbItem[] => [
  {
    id: 'model',
    name: modelName
  }
];
